import { InitService, OperationService } from "@/services";
import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";
import operationService from "@/services/modules/operationService";

const Online = () =>
  import("@/components/OperationsPage/Deposit/Rial/Online/index");
const Offline = () =>
  import("@/components/OperationsPage/Deposit/Rial/Offline/index");
const CartToCart = () =>
  import("@/components/OperationsPage/Deposit/Rial/CartToCart/index");
const PaymentID = () =>
  import("@/components/OperationsPage/Deposit/Rial/PaymentID/index");

const cartTable = () =>
  import("@/components/OperationsPage/Deposit/Rial/cartTable/index");
const directDebit = () =>
  import("@/components/OperationsPage/Deposit/Rial/DirectDebit/index");

const NotRegisteredCard = () =>
  import("@/components/BankCard/NotRegisteredCard/index");

export default {
  name: "rial",
  components: {
    NotRegisteredCard,
    Online,
    Offline,
    PaymentID,
    directDebit,
    CartToCart,
    cartTable
  },
  props: [],
  data() {
    return {
      bankList: [],
      cartPages: {},
      directDepositCart: {},
      cartTransactions: [],
      tab: "",
      paymentType: this.$t("operationsPage.deposit.category.rial.paymentType"),
      hideDialog: false,
      warningCartDialog: false,
      warningCartDialogContent: null,
      warningOnlineDialog: false,
      warningOnlineDialogContent: null
    };
  },
  watch: {
    "$route.query.paymentType": {
      handler: function() {
        if (this.$route.query.paymentType === "online") {
          this.tab = 0;
        } else if (this.$route.query.paymentType === "offline") {
          this.tab = 3;
        } else if (this.$route.query.paymentType === "paymentID") {
          this.tab = 2;
        } else if (this.$route.query.paymentType === "cartToCart") {
          this.tab = 4;
        } else if (this.$route.query.paymentType === "cart") {
          this.tab = 1;
        } else if (this.$route.query.paymentType === "direct-debit") {
          this.tab = 4;
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapGetters({
      initData: types.init.getters.GET_INIT_DATA
    })
  },
  mounted() {
    this.getInit();
    if (this.$route.query.paymentType === "online") {
      this.tab = 0;
    } else if (this.$route.query.paymentType === "offline") {
      this.tab = 3;
    } else if (this.$route.query.paymentType === "paymentID") {
      this.tab = 2;
    } else if (this.$route.query.paymentType === "cartToCart") {
      this.tab = 4;
    } else if (this.$route.query.paymentType === "cart") {
      this.tab = 1;
    } else if (this.$route.query.paymentType === "direct-debit") {
      this.tab = 4;
    }
    this.getCartData();
    this.getCartPages();
    this.getDirectDepositCart();
    this.getCartWarning();
    this.getGatewayWarning();
  },
  methods: {
    ...mapActions({
      setInit: types.init.actions.SET_INIT_DATA
    }),
    getCartData() {
      operationService.getCartPaymentBankList().then(res => {
        this.bankList = res.data.data;
      });
    },
    getCartPages() {
      operationService.getCartPaymentPage().then(res => {
        this.cartPages = res.data.data;
      });
    },
    getDirectDepositCart() {
      OperationService.getCartDirectDeposit().then(res => {
        this.directDepositCart = res.data.data;
      });
    },
    getCartWarning() {
      OperationService.getCartWarning().then(res => {
        console.log(res);
        if (res.data.data.page_content) {
          this.warningCartDialog = true;
          this.warningCartDialogContent = res.data.data.page_content;
        }
      });
    },

    getGatewayWarning() {
      OperationService.getGatewayWarning().then(res => {
        if (res.data.data.page_content) {
          this.warningOnlineDialog = true;
          this.warningOnlineDialogContent = res.data.data.page_content;
        }
      });
    },
    getInit() {
      InitService.init().then(res => {
        this.setInit(res.data.data);
      });
    },
    addQueryParameters(dataQuery) {
      this.$router.push({ query: { from: "IRR", paymentType: dataQuery } });
    },
    saveHideDialog(hide) {
      localStorage.setItem("hideOfflinePaymentNotice", hide);
    },
    onCopy() {
      this.$toast.success(this.$t("operationsPage.copy"));
    }
  }
};
